// @flow
import { OFFER_DESCRIPTION } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_OFFER_DESCRIPTION } from 'Utils/request/requestDictionary';

type LineProps = {
  offerId: string,
};

export const offerDescriptionResolver = {
  name: OFFER_DESCRIPTION,
  resolve(appContext: AppContext, props: LineProps) {
    const { offerId } = props;
    const query = `{
      offer(offerId: "${offerId}") {color timingArgument description}
      config {
        common {
          viewMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_OFFER_DESCRIPTION,
      strictErrors: false,
    });
  },
};
